import { AcceptedCountries } from '../data-types/international/internationalEnums';
import { sportCategories } from '../data-types/sports/sportsConstants';

export const getSportsOrderByCountry = (userLocation: AcceptedCountries | undefined) => {
  switch (userLocation) {
    case AcceptedCountries.ARMENIA:
      return [
        sportCategories.FOOTBALL,
        sportCategories.BASKETBALL,
        sportCategories.TENNIS,
        sportCategories.TABLE_TENNIS,
        sportCategories.VOLLEYBALL,
        sportCategories.HORSES,
        sportCategories.GOLF,
        sportCategories.ICE_HOCKEY,
        sportCategories.F1,
        sportCategories.DARTS,
        sportCategories.CRICKET,
        sportCategories.RUGBY,
        sportCategories.SNOOKER,
        sportCategories.BOXING,
        sportCategories.MMA,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.GREY_HOUNDS,
        sportCategories.BASEBALL,
        sportCategories.ELEAGUES,
      ];
    case AcceptedCountries.AUSTRIA:
      return [
        sportCategories.FOOTBALL,
        sportCategories.TENNIS,
        sportCategories.ICE_HOCKEY,
        sportCategories.BASKETBALL,
        sportCategories.HORSES,
        sportCategories.GOLF,
        sportCategories.F1,
        sportCategories.RUGBY,
        sportCategories.VOLLEYBALL,
        sportCategories.TABLE_TENNIS,
        sportCategories.DARTS,
        sportCategories.CRICKET,
        sportCategories.SNOOKER,
        sportCategories.BOXING,
        sportCategories.MMA,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.GREY_HOUNDS,
        sportCategories.BASEBALL,
        sportCategories.ELEAGUES,
      ];
    case AcceptedCountries.BOSNIA_AND_HERZEGOVINA:
      return [
        sportCategories.FOOTBALL,
        sportCategories.BASKETBALL,
        sportCategories.ICE_HOCKEY,
        sportCategories.TENNIS,
        sportCategories.HORSES,
        sportCategories.CRICKET,
        sportCategories.RUGBY,
        sportCategories.DARTS,
        sportCategories.SNOOKER,
        sportCategories.GOLF,
        sportCategories.F1,
        sportCategories.BOXING,
        sportCategories.MMA,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.GREY_HOUNDS,
        sportCategories.TABLE_TENNIS,
        sportCategories.VOLLEYBALL,
        sportCategories.BASEBALL,
        sportCategories.ELEAGUES,
      ];
    case AcceptedCountries.CANADA:
      return [
        sportCategories.ICE_HOCKEY,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.FOOTBALL,
        sportCategories.BASKETBALL,
        sportCategories.RUGBY,
        sportCategories.TENNIS,
        sportCategories.CRICKET,
        sportCategories.GOLF,
        sportCategories.MMA,
        sportCategories.BOXING,
        sportCategories.F1,
        sportCategories.DARTS,
        sportCategories.HORSES,
        sportCategories.SNOOKER,
        sportCategories.GREY_HOUNDS,
        sportCategories.TABLE_TENNIS,
        sportCategories.BASEBALL,
        sportCategories.VOLLEYBALL,
        sportCategories.ELEAGUES,
      ];
    case AcceptedCountries.CROATIA:
      return [
        sportCategories.FOOTBALL,
        sportCategories.TENNIS,
        sportCategories.BASKETBALL,
        sportCategories.VOLLEYBALL,
        sportCategories.TABLE_TENNIS,
        sportCategories.GOLF,
        sportCategories.ICE_HOCKEY,
        sportCategories.BOXING,
        sportCategories.MMA,
        sportCategories.F1,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.BASEBALL,
        sportCategories.SNOOKER,
        sportCategories.DARTS,
        sportCategories.HORSES,
        sportCategories.CRICKET,
        sportCategories.RUGBY,
        sportCategories.GREY_HOUNDS,
        sportCategories.ELEAGUES,
      ];
    case AcceptedCountries.GEORGIA:
      return [
        sportCategories.FOOTBALL,
        sportCategories.BASKETBALL,
        sportCategories.RUGBY,
        sportCategories.BOXING,
        sportCategories.MMA,
        sportCategories.HORSES,
        sportCategories.TENNIS,
        sportCategories.CRICKET,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.GOLF,
        sportCategories.F1,
        sportCategories.DARTS,
        sportCategories.SNOOKER,
        sportCategories.ICE_HOCKEY,
        sportCategories.GREY_HOUNDS,
        sportCategories.TABLE_TENNIS,
        sportCategories.BASEBALL,
        sportCategories.VOLLEYBALL,
        sportCategories.ELEAGUES,
      ];
    case AcceptedCountries.IRELAND:
      return [
        sportCategories.FOOTBALL,
        sportCategories.RUGBY,
        sportCategories.HORSES,
        sportCategories.GOLF,
        sportCategories.BOXING,
        sportCategories.MMA,
        sportCategories.TENNIS,
        sportCategories.BASKETBALL,
        sportCategories.CRICKET,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.F1,
        sportCategories.DARTS,
        sportCategories.SNOOKER,
        sportCategories.ICE_HOCKEY,
        sportCategories.GREY_HOUNDS,
        sportCategories.TABLE_TENNIS,
        sportCategories.BASEBALL,
        sportCategories.VOLLEYBALL,
        sportCategories.ELEAGUES,
      ];
    case AcceptedCountries.FINLAND:
      return [
        sportCategories.ICE_HOCKEY,
        sportCategories.FOOTBALL,
        sportCategories.BASKETBALL,
        sportCategories.HORSES,
        sportCategories.GREY_HOUNDS,
        sportCategories.RUGBY,
        sportCategories.CRICKET,
        sportCategories.DARTS,
        sportCategories.GOLF,
        sportCategories.F1,
        sportCategories.SNOOKER,
        sportCategories.BOXING,
        sportCategories.MMA,
        sportCategories.TENNIS,
        sportCategories.TABLE_TENNIS,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.BASEBALL,
        sportCategories.VOLLEYBALL,
        sportCategories.ELEAGUES,
      ];
    case AcceptedCountries.KENYA:
      return [
        sportCategories.FOOTBALL,
        sportCategories.BASKETBALL,
        sportCategories.CRICKET,
        sportCategories.RUGBY,
        sportCategories.VOLLEYBALL,
        sportCategories.TENNIS,
        sportCategories.BOXING,
        sportCategories.ICE_HOCKEY,
        sportCategories.MMA,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.HORSES,
        sportCategories.DARTS,
        sportCategories.GOLF,
        sportCategories.F1,
        sportCategories.SNOOKER,
        sportCategories.TABLE_TENNIS,
        sportCategories.GREY_HOUNDS,
        sportCategories.BASEBALL,
        sportCategories.ELEAGUES,
      ];
    case AcceptedCountries.KOSOVO:
      return [
        sportCategories.FOOTBALL,
        sportCategories.BASKETBALL,
        sportCategories.RUGBY,
        sportCategories.BOXING,
        sportCategories.MMA,
        sportCategories.TENNIS,
        sportCategories.HORSES,
        sportCategories.CRICKET,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.GOLF,
        sportCategories.F1,
        sportCategories.DARTS,
        sportCategories.SNOOKER,
        sportCategories.ICE_HOCKEY,
        sportCategories.GREY_HOUNDS,
        sportCategories.TABLE_TENNIS,
        sportCategories.VOLLEYBALL,
        sportCategories.BASEBALL,
        sportCategories.ELEAGUES,
      ];
    case AcceptedCountries.MONTENEGRO:
      return [
        sportCategories.FOOTBALL,
        sportCategories.BASKETBALL,
        sportCategories.RUGBY,
        sportCategories.VOLLEYBALL,
        sportCategories.BOXING,
        sportCategories.MMA,
        sportCategories.BASEBALL,
        sportCategories.TENNIS,
        sportCategories.HORSES,
        sportCategories.F1,
        sportCategories.CRICKET,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.GOLF,
        sportCategories.DARTS,
        sportCategories.SNOOKER,
        sportCategories.ICE_HOCKEY,
        sportCategories.GREY_HOUNDS,
        sportCategories.TABLE_TENNIS,
        sportCategories.ELEAGUES,
      ];
    case AcceptedCountries.NEW_ZEALAND:
      return [
        sportCategories.RUGBY,
        sportCategories.CRICKET,
        sportCategories.HORSES,
        sportCategories.BASKETBALL,
        sportCategories.FOOTBALL,
        sportCategories.TENNIS,
        sportCategories.GOLF,
        sportCategories.F1,
        sportCategories.BOXING,
        sportCategories.MMA,
        sportCategories.SNOOKER,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.DARTS,
        sportCategories.ICE_HOCKEY,
        sportCategories.GREY_HOUNDS,
        sportCategories.TABLE_TENNIS,
        sportCategories.BASEBALL,
        sportCategories.VOLLEYBALL,
        sportCategories.ELEAGUES,
      ];
    case AcceptedCountries.NORWAY:
      return [
        sportCategories.FOOTBALL,
        sportCategories.ICE_HOCKEY,
        sportCategories.BASKETBALL,
        sportCategories.TENNIS,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.BOXING,
        sportCategories.MMA,
        sportCategories.HORSES,
        sportCategories.GREY_HOUNDS,
        sportCategories.F1,
        sportCategories.GOLF,
        sportCategories.TABLE_TENNIS,
        sportCategories.RUGBY,
        sportCategories.DARTS,
        sportCategories.SNOOKER,
        sportCategories.CRICKET,
        sportCategories.BASEBALL,
        sportCategories.VOLLEYBALL,
        sportCategories.ELEAGUES,
      ];
    case AcceptedCountries.SERBIA:
      return [
        sportCategories.FOOTBALL,
        sportCategories.BASKETBALL,
        sportCategories.TENNIS,
        sportCategories.ICE_HOCKEY,
        sportCategories.BOXING,
        sportCategories.MMA,
        sportCategories.HORSES,
        sportCategories.CRICKET,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.GOLF,
        sportCategories.F1,
        sportCategories.DARTS,
        sportCategories.SNOOKER,
        sportCategories.RUGBY,
        sportCategories.GREY_HOUNDS,
        sportCategories.TABLE_TENNIS,
        sportCategories.VOLLEYBALL,
        sportCategories.BASEBALL,
        sportCategories.ELEAGUES,
      ];
    case AcceptedCountries.SLOVENIA:
      return [
        sportCategories.FOOTBALL,
        sportCategories.BASKETBALL,
        sportCategories.ICE_HOCKEY,
        sportCategories.TENNIS,
        sportCategories.BOXING,
        sportCategories.MMA,
        sportCategories.HORSES,
        sportCategories.GOLF,
        sportCategories.F1,
        sportCategories.CRICKET,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.DARTS,
        sportCategories.SNOOKER,
        sportCategories.RUGBY,
        sportCategories.GREY_HOUNDS,
        sportCategories.TABLE_TENNIS,
        sportCategories.BASEBALL,
        sportCategories.VOLLEYBALL,
        sportCategories.ELEAGUES,
      ];
    case AcceptedCountries.UNITED_ARAB_EMIRATES:
      return [
        sportCategories.FOOTBALL,
        sportCategories.HORSES,
        sportCategories.CRICKET,
        sportCategories.TENNIS,
        sportCategories.BASKETBALL,
        sportCategories.RUGBY,
        sportCategories.GOLF,
        sportCategories.F1,
        sportCategories.BOXING,
        sportCategories.MMA,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.ICE_HOCKEY,
        sportCategories.DARTS,
        sportCategories.SNOOKER,
        sportCategories.GREY_HOUNDS,
        sportCategories.TABLE_TENNIS,
        sportCategories.VOLLEYBALL,
        sportCategories.BASEBALL,
        sportCategories.ELEAGUES,
      ];
    case AcceptedCountries.SWITZERLAND:
      return [
        sportCategories.FOOTBALL,
        sportCategories.TENNIS,
        sportCategories.ICE_HOCKEY,
        sportCategories.BASKETBALL,
        sportCategories.HORSES,
        sportCategories.GOLF,
        sportCategories.F1,
        sportCategories.RUGBY,
        sportCategories.VOLLEYBALL,
        sportCategories.TABLE_TENNIS,
        sportCategories.DARTS,
        sportCategories.CRICKET,
        sportCategories.SNOOKER,
        sportCategories.BOXING,
        sportCategories.MMA,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.GREY_HOUNDS,
        sportCategories.BASEBALL,
        sportCategories.ELEAGUES,
      ];
    case AcceptedCountries.INDIA:
      return [
        sportCategories.CRICKET,
        sportCategories.FOOTBALL,
        sportCategories.TENNIS,
        sportCategories.BASKETBALL,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.ICE_HOCKEY,
        sportCategories.BOXING,
        sportCategories.MMA,
        sportCategories.HORSES,
        sportCategories.DARTS,
        sportCategories.GOLF,
        sportCategories.F1,
        sportCategories.SNOOKER,
        sportCategories.TABLE_TENNIS,
        sportCategories.RUGBY,
        sportCategories.GREY_HOUNDS,
        sportCategories.BASEBALL,
        sportCategories.VOLLEYBALL,
        sportCategories.ELEAGUES,
      ];
    case AcceptedCountries.BRAZIL:
    case AcceptedCountries.MEXICO:
    case AcceptedCountries.COLOMBIA:
    case AcceptedCountries.CHILE:
    case AcceptedCountries.PERU:
    case AcceptedCountries.ARGENTINA:
    case AcceptedCountries.ECUADOR:
    case AcceptedCountries.EL_SALVADOR:
    case AcceptedCountries.PARAGUAY:
    case AcceptedCountries.URUGUAY:
      return [
        sportCategories.FOOTBALL,
        sportCategories.BASKETBALL,
        sportCategories.TENNIS,
        sportCategories.TABLE_TENNIS,
        sportCategories.MMA,
        sportCategories.VOLLEYBALL,
        sportCategories.BASEBALL,
        sportCategories.BOXING,
        sportCategories.HORSES,
        sportCategories.GOLF,
        sportCategories.F1,
        sportCategories.AMERICAN_FOOTBALL,
        sportCategories.ICE_HOCKEY,
        sportCategories.SNOOKER,
        sportCategories.DARTS,
        sportCategories.RUGBY,
        sportCategories.CRICKET,
        sportCategories.GREY_HOUNDS,
        sportCategories.ELEAGUES,
      ];
    default:
      return undefined;
  }
};
